
// import { faBook } from "@fortawesome/pro-light-svg-icons/faBook";
// import { faCog } from "@fortawesome/pro-light-svg-icons/faCog";
// import { faComments } from "@fortawesome/pro-light-svg-icons/faComments";
// import { faGasPump } from "@fortawesome/pro-light-svg-icons/faGasPump";
//import { faHome } from "@fortawesome/pro-light-svg-icons/faHome";
// import {faHome, faBook, faAddressBook, faAddressCard } from "@fortawesome/pro-solid-svg-icons";
// import { faPeopleGroup } from "@fortawesome/pro-solid-svg-icons/faPeopleGroup";
// import { faQuestionSquare } from "@fortawesome/pro-light-svg-icons/faQuestionSquare";
// import { faSignOutAlt } from "@fortawesome/pro-light-svg-icons/faSignOutAlt";
// import { faUser } from "@fortawesome/pro-light-svg-icons/faUser";
// import { faUserGraduate } from "@fortawesome/pro-light-svg-icons/faUserGraduate";
import { lazy } from "react";
import { Route } from "router5"; 
import { NavigationCategory, NavigationCategoryItem } from "./NavigationCategory";

const Home = lazy(() => import("../pages/Home/Home"));
const Contact = lazy(() => import("../pages/Contact/Contact"));
const Educators = lazy(() => import("../pages/Educators/Educators"));
const About = lazy(() => import("../pages/About/About"));
const Programs = lazy(() => import("../pages/Programs/Programs")); 
const NotFound = lazy(() => import("../components/NotFound/NotFound")); 

export interface ExtendedRoute extends Route {
    activate?: (store: any, nextParams: any) => void;
    deactivate?: (store: any, prevParams: any) => void;
    children?: ExtendedRoute[];
    // Which component to load for a given route.
    component?: React.LazyExoticComponent<React.FC<any>>;
    // If user is logged in - redirect to home whenever this route is loaded.
    redirectToHome?: boolean;
}

export enum RouteName {
    Base = "base", 
    Contact = "contact",
    Educators = "educators",
    About = "about",
    Programs = "programs",  
    NotFound = "notfound",  
    
}

export const getRouteDisplayName = (routeName?: RouteName) => {
    switch (routeName) {
        case RouteName.Base: return "Home"; 
        case RouteName.Contact: return "Contact Us";
        case RouteName.Educators: return "Our Educators";
        case RouteName.About: return "About Us";
        case RouteName.Programs: return "Our Programs";
        case RouteName.NotFound: return "Not found";
        default: return undefined;
    }
}

export const joinRoutes = (...names: string[]) => names.join(".");

export const routes: ExtendedRoute[] = [
    
    {
        name: RouteName.Base,
        path: "/",
        component: Home,
    },
    {
        name: RouteName.Contact,
        path: "/contact",
        component: Contact
    },
    {
        name: RouteName.Educators,
        path: "/educators",
        component: Educators
    },
    {
        name: RouteName.About,
        path: "/about",
        component: About
    },
    {
        name: RouteName.Programs,
        path: "/programs",
        component: Programs
    }, 
    {
        name: RouteName.NotFound,
        path: "/404",
        component: NotFound
    }, 
];

const buildItem = (routeName: RouteName): NavigationCategoryItem => ({ routeName, displayName: getRouteDisplayName(routeName) ?? "" })

const homeItems: NavigationCategoryItem[] = [
    buildItem(RouteName.Base),
];
const AboutItems: NavigationCategoryItem[] = [
    buildItem(RouteName.About),
];
const EducatorsItems: NavigationCategoryItem[] = [
    buildItem(RouteName.Educators),
];
const ProgramsItems: NavigationCategoryItem[] = [
    buildItem(RouteName.Programs),
];
const ContactItems: NavigationCategoryItem[] = [
    buildItem(RouteName.Contact),
]; 

 
const AllItems: NavigationCategoryItem[] = [
    buildItem(RouteName.Base),
    buildItem(RouteName.About),
    buildItem(RouteName.Educators),
    buildItem(RouteName.Programs),
    buildItem(RouteName.Contact), 
] 


export const NAVIGATION_CATEGORIES: NavigationCategory[] = [
    { categoryName: "Home", items: homeItems, icon: "fa-solid fa-home" },
    { categoryName: "About Us", items: AboutItems, icon: "fa-solid fa-address-card" }, 
    { categoryName: "Our Educators", items: EducatorsItems, icon: "fa-solid fa-people-group" }, 
    { categoryName: "Our Programs", items: ProgramsItems, icon: "fa-solid fa-book" }, 
    { categoryName: "Contact Us", items: ContactItems, icon: "fa-solid fa-address-book" },  
]

